__turbopack_context__.v({
  "productName": "ProductName-module-scss-module__hAh9aq__productName",
  "whiteLabeled": "ProductName-module-scss-module__hAh9aq__whiteLabeled",
});
